import { render, staticRenderFns } from "./entity-card-documents-list.vue?vue&type=template&id=bc4e7b96&"
import script from "./entity-card-documents-list.vue?vue&type=script&lang=js&"
export * from "./entity-card-documents-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports